import React, { useState } from 'react'
import { ErrorMessage } from 'formik'
import ErrorRow from './ErrorRow'
import classNames from 'classnames'
import PrettyCheckbox from '../../pretty_checkbox/PrettyCheckbox'

/**
 *
 * @param {object} field
 * @description contain { onChange, onBlur, name, value }
 * @link https://jaredpalmer.com/formik/docs/api/useField#fieldinputpropsvalue
 *
 * @param {object} meta
 * @description contain { value, touched, error, initialValue }
 * @link https://jaredpalmer.com/formik/docs/api/useField#fieldmetapropsvalue
 *
 * @param {object} form
 *
 */
export const Checkbox = ({
    field,
    form,
    label,
    customError: ErrorComponent,
    withoutMargin,
    onChange = () => {},
    ...props
}) => {
    const { name } = field;
    const { disabled = false } = props;
    const isValid = !(form.errors[name] && form.touched[name]);
    const [checked, setChecked] = useState(props.checked);

    const handleChange = e => {
        const isChecked = e.target.checked;
        setChecked(isChecked);
        onChange(isChecked);
        field.onChange(e);
    }

    return (
        <div className={classNames("form-group", `form-group-${name}`, { 'form-error': !isValid, 'form-disabled': disabled, 'without-margin': withoutMargin })}>
            <div className={classNames("form-info")}>
                {ErrorComponent ?
                    <ErrorComponent /> :
                    <ErrorMessage name={name} component={ErrorRow} />}
            </div>
            <div className="form-input-checkbox">
                <PrettyCheckbox {...field} {...props} checked={checked} onCheckChange={handleChange}>
                    {label}
                </PrettyCheckbox>
            </div>
        </div>
    );
};
